import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import { Box, Link, styled } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import React, { useEffect, useState } from "react";
import ReactImageGallery from "react-image-gallery";
import { primary } from "../../constants/theme";
import { VehicleBrochure } from "../../constants/vehicleData";
import { sendAnalytics } from "../../utils/analyticsCommon";

const CustomeVehicleLisPopUp = styled(Box)(({ theme }) => ({
  minHeight: "300px",
  minWidth: "300px",
  ".slider-box": {
    margin: "60px 0px 00px 0px",
    width: "100%",
    borderRadius: "10px",
  },
  ".dialog-box": {
    padding: "4px",
    minHeight: "400px",
    minWidth: "400px",
  },
  ".image-gallery-bullet": {
    backgroundColor: `${primary.greyText} !important`,
    boxShadow: "none !important",
  },
  ".image-gallery-bullet.active": {
    backgroundColor: `${primary.black} !important`,
  },
  ".broucher-download-btn": {
    background: "#FEEBEF",
    width: "fit-content",
    display: "flex",
    alignItems: "center",
    borderRadius: "8px",
    padding: "5px",
  },
  ".book-test-drive-button": {
    borderRadius: "8px !important",
    boxShadow: "none !important",
    border: "none !important",
    paddingLeft: "10px !important",
    paddingRight: "10px !important",
    "&:hover": {
      background: "#F63B63",
      border: "none",
      color: "white",
      boxShadow: "none",
      paddingLeft: "10px",
      paddingRight: "10px",
    },
  },
  ".MuiOutlinedInput-root": {
    //need to use class to explicitly change the MUI styling
    paddingRight: "2px !important",
  },
  [theme.breakpoints.down("md")]: {
    marginBottom: "20px",
  },
}));
const VehicleListPop = ({ open, vehicleData, onClose }) => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    let imagesArray = [];
    if (vehicleData?.galleryViewImages) {
      vehicleData?.galleryViewImages?.map((image) => {
        imagesArray.push({
          original: image?.src,
        });
      });
    } else {
      imagesArray.push({ original: vehicleData?.storeImage });
    }
    setImages(imagesArray);
  }, [vehicleData]);
  return (
    <Dialog onClose={onClose} open={open} className="dialog-box" style={{}}>
      <DialogContent>
        <CustomeVehicleLisPopUp>
          <Box>
            <Box style={{ display: "flex", justifyContent: "space-between" }}>
              <Box
                style={{
                  background: "#FEEBEF",
                  width: "fit-content",
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "50%",
                  padding: "5px",
                  cursor: "pointer",
                }}
              >
                <CloseIcon onClick={onClose} />
              </Box>
              <Box>
                <Link
                  id="performance-range"
                  target="_blank"
                  href={
                    VehicleBrochure[vehicleData?.vehicle_name] ||
                    VehicleBrochure[vehicleData?.brand?.toLowerCase()]
                  }
                  hrefLang={"en"}
                  rel="noreferrer"
                  underline="none"
                  onClick={() => {
                    let payload = {
                      vehicle_name: vehicleData?.name,
                      vehicle_id: vehicleData?.id,
                    };
                    sendAnalytics(
                      "v2_vehicle_brochure_download_clicked",
                      payload,
                      "en"
                    );
                  }}
                >
                  <Box className="broucher-download-btn">
                    Download Brochure
                    <DownloadIcon sx={{ color: "#F63B63" }} />
                  </Box>
                </Link>
              </Box>
            </Box>

            <Box className="slider-box">
              <ReactImageGallery
                autoPlay={false}
                showNav={true}
                showBullets={true}
                style={{ height: "2px" }}
                items={images}
                showThumbnails={false}
                showFullscreenButton={false}
                showPlayButton={false}
                onSlide={() => {
                  let payload = {
                    vehicle_name: vehicleData?.name,
                    vehicle_id: vehicleData?.id,
                  };
                  sendAnalytics(
                    "v2_vehicle_image_slide_button_clicked",
                    payload,
                    "en"
                  );
                }}
              />
            </Box>
          </Box>
        </CustomeVehicleLisPopUp>
      </DialogContent>
    </Dialog>
  );
};

export default VehicleListPop;
